import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { success, error } from "../common/helpers/toastify";
import { useTranslation } from "react-i18next";
import { toFormatPrice } from "../common/helpers/function";
import { useSelector } from "react-redux";
import { _Api } from "../common/api/_call";



const OrderModal = ({
  id = "orderModal",
  items = [],
  AddtoCart,
  reserve,
  setReserve,
  isCrown,
  parentid,
  crosslocation,
  crossLocationId
}) => {
  const { t } = useTranslation();
  const [product_id, setProductId] = useState("");
  const [selectedId, setSelectedId] = useState([]);
  const navigate = useNavigate();
    const saleperson = useSelector((state) => state.app.saleperson);
    const customer = useSelector((state) => state.app.customer);
  const handleCheckboxChange = (e) => {
    const { checked, value } = e.target;
    let updatedIds = [...selectedId];

    if (checked) {
      // Add ID if not already in the list
      if (!updatedIds.includes(value)) {
        updatedIds.push(value);
      }
    } else {
      // Remove ID if unchecked
      updatedIds = updatedIds.filter((id) => id !== value);
    }
    setProductId(e.target.value);
    setSelectedId(updatedIds);
  };
    const addtocustomcart = async () => {
      // if (!customer?.id) {
      //   error(t("Customer is Requried!!"));
      //   return;
      // }
      // if (!saleperson?.value) {
      //   error(t("SalePerson is Requried!!"));
      //   return;
      // }
      try {
        const clearpostdata = {};
        let res = await _Api(clearpostdata, `api/v1/POS/customOrder/cartClear`);
        if (res?.code === 200) {
          localStorage.removeItem("showcheckout");
          const postdata = {
            // parentproduct_id: product_id,
            product_type:"catalog",
            order_type: "custom_order",
            customer_id: customer?.id,
            sales_person_id: saleperson?.value,
            productsIds:selectedId,
            // metal: metalListCrown,
            // size: sizeListCrown,
            // stone: stoneListCrown,
          };
          let res = await _Api(postdata, `api/v1/POS/home/addToCarts`);
          if (res.success === true) {
            success(t(res?.message));
            navigate("/app/pos/custom/createYourOwnSetting", {
              state: { cartid: res?.data, filtertype: isCrown },
            });
          } else {
            error(t("This Product Already in cart!!"));
          }
        }
      } catch (err) {
        console.log(err, "err");
      }
    };

  const handleSubmit = () => {
    if(!isCrown){
    if (reserve) {
      if (selectedId.length === 0) {
        error("Please select at least one item to reserve.");
        return;
      }
      navigate("/app/pos/reserveproduct", { state: { ids: selectedId, location: false, ...(crosslocation ? { crosslocation, crossLocationId } : {}) } });
    } else {
      if (selectedId.length === 0) {
        error("Please select an item to add to cart.");
        return;
      }
      AddtoCart(selectedId);
    }
  } else {
      if (selectedId.length === 0) {
        error("Please select at least one item to order.");
        return;
      }
      addtocustomcart();
  }
  };
  return (
    <div
      className="modal fade common-modal service-modal"
      id={id}
      tabIndex="-1"
      aria-labelledby="orderModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div
          className="modal-content p-3"
          style={{ borderRadius: "0" }}
        >
          <div
            className="modal-header"
            style={{ borderBottom: "none", padding: "1vh 0" }}
          >
            <h5 className="modal-title fw-bold d-flex" id="orderModalLabel">
              {t("Order")}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                setReserve(false);
                setSelectedId([]);
                setProductId("");
              }}
            />
          </div>
          <div className="modal-body">
            <p className="fw-semibold mb-3 d-flex">
              {" "}
              {t("Select item to order")}
            </p>
            <div
              className="list-group"
              style={{
                maxHeight: "40vh",
                overflowY: "scroll",
                borderRadius: "0",
              }}
            >
              {items.map((item, index) => (
                <label
                  key={index}
                  className="list-group-item d-flex justify-content-between align-items-center"
                  // style={(index+1)%2==0? {backgroundColor: "#FAFAFA"} : {backgroundColor: "#F4F4F4"}}
                  style={{backgroundColor:selectedId.includes(item._id) ? "#E1F3F2" : (index+1)%2===0? "#FAFAFA" : "#F4F4F4"}}
                >
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={item._id}
                      checked={selectedId.includes(item._id)}
                      name="orderItem"
                      onChange={(e) => handleCheckboxChange(e)}
                      style={{borderRadius: "0",border:"none"}}
                    />
                    <div className="ms-2">
                      <div className="fw-bold">{item.SKU}</div>
                      {item?.stock_id?<small className="text-muted d-flex">{item.stock_id}</small>:""}
                    </div>
                  </div>
                  <div className="text-end">
                    {item?.po_QTY?<div className="fw-bold">{item.po_QTY} pcs</div>:""}
                    <small className="text-muted">{toFormatPrice(item.price,{ addSymbol: true })}</small>
                  </div>
                </label>
           
              ))}
            </div>
          </div>
          <div style={{border:"1px solid #E3E3E3",marginTop:"30px"}}></div>
          <div className="modal-footer justify-content-end">
            <button
              type="button"
              className="btn btn-outline-secondary btn-cancel"
              data-bs-dismiss="modal"
              style={{ borderRadius: "3px",height:"3.6vh",minWidth:"4.7vw" }}
              onClick={() => {
                setReserve(false);
                setSelectedId([]);
                setProductId("");
              }}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-submit"
              data-bs-dismiss="modal"
              onClick={handleSubmit}
              style={{ borderRadius: "3px", backgroundColor: "#52CBC4",height:"3.6vh",minWidth:"4.7vw" }}
            >
              {t("Submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderModal;
